export enum FEATURES {
  DEVELOPER_API = 'DEVELOPER_API',
  QUICKSELL_BOT = 'QUICKSELL_BOT',
  SHOPIFY_INTEGRATION = 'SHOPIFY_INTEGRATION',
  ROLES_AND_PERMISSIONS = 'ROLES_AND_PERMISSIONS',
  GOOGLE_SHEETS_INTEGRATION = 'GOOGLE_SHEETS_INTEGRATION',
  OPEN_AI_INTEGRATION = 'OPEN_AI_INTEGRATION',
  SLA_STATUS = 'SLA_STATUS',
}
